import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/folders.action'
import editFolder from 'api/administration/folders/Edit'
import foldersList from 'api/administration/folders/List'
import I18n from '../../../i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { IFolderModel } from 'models/folder.model'

async function getList() {
  return await foldersList()
}

async function handleEdit(data: IFolderModel, idFolder: number) {
  return await editFolder(data, idFolder)
}

function* editFolderEffectSaga(action: any) {
  try {
    // FIRST EDIT THE FOLDER
    const { folder, id } = action.payload

    yield call(handleEdit, folder, id)

    // SECOND RELOAD DATA
    const { data } = yield call(getList)
    yield put(fromActions.Actions.foldersAdministrationListSuccess(data))

    SuccessToast(I18n.t('administration.toastMessages.editSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.editError'))
    console.log('error: ', error)
  }
}

export function* editFolderWatcherSaga() {
  yield takeLatest(fromActions.UPDATE_FOLDER, editFolderEffectSaga)
}
